import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { logErrorAsync } from '_lib/utility.js'

const useRequest = (func, payload, hasData) => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null,
  })

  useEffect(() => {
    if (hasData) {
      // cleanup
      setState({
        data: null,
        loading: true,
        error: null,
      })
      func(payload)
        // success
        .then((data) =>
          setState({
            data,
            loading: false,
            error: null,
          })
        )
        // error
        .catch((error) => {
          logErrorAsync(error)
          setState({
            data: null,
            loading: false,
            error: error,
          })
        })
    } else {
      // empty
      setState({
        data: null,
        loading: false,
        error: null,
      })
    }
  }, [func, JSON.stringify(payload), hasData])

  return state
}

useRequest.propTypes = {
  func: PropTypes.func.isRequired,
  payload: PropTypes.object.isRequired,
  hasData: PropTypes.bool.isRequired,
}

export default useRequest
